module.exports = __webpack_public_path__ + "media/how_does_sharing_work/painting-f8b23235.svg";